import BulkCreateAttributeSelect from './bulkCreateAttributeSelect.container';

export default BulkCreateAttributeSelect